import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { Button } from "@/shared/ui-kit/Button";

const KEY = "pro-roller.cookies_consent";

type Consent = { essenciais: true; analytics: boolean; marketing: boolean; setAt: string };

export function CookieBanner() {
  const [show, setShow] = useState(false);
  const [conf, setConf] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    setShow(localStorage.getItem(KEY) === null);
  }, []);

  function salvar(consent: Consent) {
    localStorage.setItem(KEY, JSON.stringify(consent));
    setShow(false);
  }

  // Telas OBS (browser source) não têm interação — o aviso de cookies não deve aparecer nelas.
  if (!show || window.location.pathname.startsWith("/obs/")) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-title"
      style={{
        position: "fixed", bottom: 16, left: 16, right: 16,
        maxWidth: 720, margin: "0 auto",
        background: "var(--surface)", border: "1px solid var(--line)",
        borderRadius: "var(--r-lg)", boxShadow: "var(--sh-3)",
        padding: 20, zIndex: 900,
      }}
    >
      <h2 id="cookie-title" style={{ fontSize: 18, marginBottom: 8 }}>Sobre cookies aqui</h2>
      <p style={{ fontSize: 14, color: "var(--ink-2)" }}>
        A gente usa cookies essenciais pra manter sua sessão. Os opcionais ajudam a melhorar o
        produto e são desligados por padrão.{" "}
        <Link to="/politica-privacidade">Política completa</Link>.
      </p>

      {conf && (
        <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 8, fontSize: 14 }}>
          <label style={{ display: "flex", gap: 8 }}>
            <input type="checkbox" checked disabled /> Essenciais (obrigatório)
          </label>
          <label style={{ display: "flex", gap: 8 }}>
            <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} /> Analytics — entender uso
          </label>
          <label style={{ display: "flex", gap: 8 }}>
            <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} /> Comunicações de produto
          </label>
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16, flexWrap: "wrap" }}>
        {conf ? (
          <>
            <Button variant="ghost" onClick={() => setConf(false)}>← Voltar</Button>
            <Button
              variant="primary"
              onClick={() => salvar({ essenciais: true, analytics, marketing, setAt: new Date().toISOString() })}
            >
              Salvar escolhas
            </Button>
          </>
        ) : (
          <>
            <Button variant="ghost" onClick={() => setConf(true)}>Configurar</Button>
            <Button
              variant="secondary"
              onClick={() => salvar({ essenciais: true, analytics: false, marketing: false, setAt: new Date().toISOString() })}
            >
              Só essenciais
            </Button>
            <Button
              variant="primary"
              onClick={() => salvar({ essenciais: true, analytics: true, marketing: true, setAt: new Date().toISOString() })}
            >
              Aceitar todos
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
